import { cva, type VariantProps } from "../../lib";
import type { TextFieldVisualState } from "../text-field";

/**
 * TextArea container variants — mirrors textFieldContainerVariants
 * but with multi-line sizing: `rows` sets the height, not a fixed one. `md:` is
 * Figma's desktop mode of the same padding and radius variables (153:2165).
 */
export const textAreaContainerVariants = cva(
  "native:flex rounded-radius-md md:rounded-radius-lg px-spacing-md md:px-spacing-lg py-spacing-sm md:py-spacing-md flex w-full flex-row overflow-hidden",
  {
    variants: {
      visualState: {
        default: [
          "border-luce-neutral-border-mediumEmphasis border-1",
          "bg-luce-neutral-background-default",
          "web:hover:border-luce-neutral-border-highEmphasis",
        ].join(" "),
        focused: [
          "border-luce-brand-primaryBorder border-1-5",
          "bg-luce-neutral-background-default",
        ].join(" "),
        error: [
          "border-luce-system-danger-default border-1-5",
          "bg-luce-neutral-background-default",
        ].join(" "),
        disabled: [
          "border-luce-neutral-border-mediumEmphasis border-1",
          "bg-luce-neutral-background-intermediate",
        ].join(" "),
      },
    },
    defaultVariants: {
      visualState: "default",
    },
  },
);

export type TextAreaContainerVariantsProps = VariantProps<typeof textAreaContainerVariants>;

/**
 * Placeholder color class per visual state. Unlike TextField, Figma keeps it
 * intermediate while the field is focused (153:2310). The error placeholder
 * waits on the designer's Figma branch (split row 72).
 */
export const textAreaPlaceholderClass: Record<TextFieldVisualState, string> = {
  default: "placeholder:text-luce-neutral-foreground-intermediate",
  focused: "placeholder:text-luce-neutral-foreground-intermediate",
  error: "placeholder:text-luce-neutral-foreground-intermediate",
  disabled: "placeholder:text-luce-neutral-foreground-attenuated",
};
